import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import {
  listAdminsReducer,
  singleAdminReducer,
  createAdminReducer,
  updateAdminReducer,
} from "reducers/adminReducers";
import {
  listOrdersReducer,
  statsOrdersReducer,
  orderSingleReducer,
  createOrderReducer,
  updateOrderReducer,
  deleteOrderReducer,
  listIncompleteOrdersReducer,
  listApprovedOrdersReducer,
  listShippingOrderReducer,
  listDeliveriesOrdersReducer,
} from "reducers/orderReducers";
import {
  listClientsReducer,
  singleClientReducer,
  createClientReducer,
  updateClientReducer,
  activateDeactivateClientReducer,
  deleteClientReducer,
} from "reducers/clientReducers";
import {
  listUsersReducer,
  singleUserReducer,
  getMeReducer,
  createUserReducer,
  updateUserReducer,
  resetUserPasswordReducer,
  activateDeactivateUserReducer,
  deleteUserReducer,
} from "reducers/userReducers";
import {
  listServicesReducer,
  servicePostReducer,
  updateServiceReducer,
  deleteServiceReducer,
} from "reducers/serviceReducers";
import {
  listAddonsReducer,
  singleAddonsReducer,
  addonCreateReducer,
  addonUpdateReducer,
  addonDeleteReducer,
} from "reducers/addonReducers";
import {
  listSuppliersReducer,
  singleSuppliersReducer,
  suppliersPostReducer,
  updateSuppliersReducer,
  deleteSuppliersReducer,
} from "reducers/supplierReducers";
import {
  listTransactionsReducer,
  statsTransactionsReducer,
  incompleteTransactionsReducer,
  orderTransactionReducer,
  singleTransactionReducer,
  createTransactionReducer,
  mpesaStkTransactionReducer,
  updateTransactionReducer,
  deleteTransactionReducer,
} from "reducers/transactionReducers";
import {
  paymentInfoReducer,
  updatePaymentInfoReducer,
} from "reducers/infoReducers";
import {
  listProductsReducer,
  statsProductsReducer,
  singleProductReducer,
  listProductsPerServiceReducer,
  createProductReducer,
  updateProductReducer,
  deleteProductReducer,
} from "reducers/productReducers";
import {
  listProductRequirementsReducer,
  singleProductRequirementsReducer,
  productRequirementCreateReducer,
  productRequirementUpdateReducer,
  productRequirementDeleteReducer,
} from "reducers/productRequirementReducers";
import {
  listResponsePerClientRequirementsReducer,
  singleResponseRequirementsReducer,
  responseRequirementCreateReducer,
  responseRequirementUpdateReducer,
  responseRequirementDeleteReducer,
} from "reducers/responseRequirementReducers";
import {
  listComplaintReducer,
  statsComplaintReducer,
  singleComplaintReducer,
  pendingComplaintReducer,
  postComplaintReducer,
  updateComplaintReducer,
  updateComplaintStatusReducer,
  deleteComplaintReducer,
} from "reducers/complaintReducers";
import {
  listComplaintRequirementsReducer,
  singleComplaintRequirementsReducer,
  complaintRequirementCreateReducer,
  complaintRequirementUpdateReducer,
  complaintRequirementDeleteReducer,
} from "reducers/complaintRequirementReducers";
import {
  supplierStatsReducer,
  // statsByAgeReducer,
  statsClientsJoinedPerMonthReducer,
  statsNewOrdersPerMonthReducer,
  proSupSerComTopPerformingReducer,
  overallSupplierStatsReducer,
} from "reducers/statsReducers";

const reducer = combineReducers({
  listAdmins: listAdminsReducer,
  singleAdmin: singleAdminReducer,
  createAdmin: createAdminReducer,
  updateAdmin: updateAdminReducer,
  listProducts: listProductsReducer,
  statsProducts: statsProductsReducer,
  singleProduct: singleProductReducer,
  listProductsPerService: listProductsPerServiceReducer,
  createProduct: createProductReducer,
  updateProduct: updateProductReducer,
  deleteProduct: deleteProductReducer,
  listProductRequirements: listProductRequirementsReducer,
  singleProductRequirements: singleProductRequirementsReducer,
  productRequirementCreate: productRequirementCreateReducer,
  productRequirementUpdate: productRequirementUpdateReducer,
  productRequirementDelete: productRequirementDeleteReducer,
  listClients: listClientsReducer,
  singleClient: singleClientReducer,
  createClient: createClientReducer,
  updateClient: updateClientReducer,
  activateDeactivateClient: activateDeactivateClientReducer,
  deleteClient: deleteClientReducer,
  listUsers: listUsersReducer,
  singleUser: singleUserReducer,
  getMe: getMeReducer,
  createUser: createUserReducer,
  updateUser: updateUserReducer,
  resetUserPassword: resetUserPasswordReducer,
  activateDeactivateUser: activateDeactivateUserReducer,
  deleteUser: deleteUserReducer,
  listAddons: listAddonsReducer,
  singleAddons: singleAddonsReducer,
  addonCreate: addonCreateReducer,
  addonUpdate: addonUpdateReducer,
  addonDelete: addonDeleteReducer,
  listServices: listServicesReducer,
  servicePost: servicePostReducer,
  updateService: updateServiceReducer,
  deleteService: deleteServiceReducer,
  listSuppliers: listSuppliersReducer,
  singleSuppliers: singleSuppliersReducer,
  suppliersPost: suppliersPostReducer,
  updateSuppliers: updateSuppliersReducer,
  deleteSuppliers: deleteSuppliersReducer,
  listTransactions: listTransactionsReducer,
  statsTransactions: statsTransactionsReducer,
  incompleteTransactions: incompleteTransactionsReducer,
  orderTransaction: orderTransactionReducer,
  singleTransaction: singleTransactionReducer,
  createTransaction: createTransactionReducer,
  mpesaStkTransaction: mpesaStkTransactionReducer,
  updateTransaction: updateTransactionReducer,
  deleteTransaction: deleteTransactionReducer,
  paymentInfo: paymentInfoReducer,
  updatePaymentInfo: updatePaymentInfoReducer,
  listOrders: listOrdersReducer,
  statsOrders: statsOrdersReducer,
  orderSingle: orderSingleReducer,
  createOrder: createOrderReducer,
  updateOrder: updateOrderReducer,
  deleteOrder: deleteOrderReducer,
  listIncompleteOrders: listIncompleteOrdersReducer,
  listApprovedOrders: listApprovedOrdersReducer,
  listShippingOrder: listShippingOrderReducer,
  listDeliveriesOrders: listDeliveriesOrdersReducer,
  listComplaint: listComplaintReducer,
  statsComplaint: statsComplaintReducer,
  singleComplaint: singleComplaintReducer,
  pendingComplaints: pendingComplaintReducer,
  postComplaints: postComplaintReducer,
  updateComplaints: updateComplaintReducer,
  updateComplaintStatus: updateComplaintStatusReducer,
  deleteComplaints: deleteComplaintReducer,
  listComplaintRequirements: listComplaintRequirementsReducer,
  singleComplaintRequirements: singleComplaintRequirementsReducer,
  complaintRequirementCreate: complaintRequirementCreateReducer,
  complaintRequirementUpdate: complaintRequirementUpdateReducer,
  complaintRequirementDelete: complaintRequirementDeleteReducer,
  listResponsePerClientRequirements: listResponsePerClientRequirementsReducer,
  singleResponseRequirements: singleResponseRequirementsReducer,
  responseRequirementCreate: responseRequirementCreateReducer,
  responseRequirementUpdate: responseRequirementUpdateReducer,
  responseRequirementDelete: responseRequirementDeleteReducer,
  supplierStats: supplierStatsReducer,
  // statsByAge: statsByAgeReducer,
  statsClientsJoinedPerMonth: statsClientsJoinedPerMonthReducer,
  statsNewOrdersPerMonth: statsNewOrdersPerMonthReducer,
  proSupSerComTopPerforming: proSupSerComTopPerformingReducer,
  overallSupplierStats: overallSupplierStatsReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
